module.exports = __webpack_public_path__ + "static/media/CommercialReel-500x250-Animated.70052b4b.mp4";